import { useEffect, useState } from 'react';
import { DriverFinancialModel } from '../../../models/driverFinancial';
import { DEFAULT_ROWS_PER_PAGE } from '../../../config-global';
import { OrderDriverFinancial } from '../../../models/orderDriverFinancial';
import {
  CLEAR_MONEY_DRIVER_FINANCIAL,
  CONFIRM_SUBMISSION,
} from '../../../lib/endpoints/driverFinancial';
import axios from '../../../lib/axios';
import { BalanceModel } from '../../../models/balanceModel';

interface Props {
  onClose: VoidFunction;
  selectedData: DriverFinancialModel;
  onFetchData: Function;
}

const useRiderBalanceDetailController = ({ onClose, selectedData, onFetchData }: Props) => {
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [openViewOrder, setOpenViewOrder] = useState<boolean>(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [selectedId, setSelectedId] = useState<string>(null!);
  const [openConfirmSubmission, setOpenConfirmSubmission] = useState<boolean>(false);

  const [getMoneyRiderPayment, setGetMoneyRiderPayment] = useState<number>(0);

  const handleOpenConfirmSubmission = () => {
    if (
      getMoneyRiderPayment === totalMoneyNeedToPay ||
      getMoneyRiderPayment < totalMoneyNeedToPay
    ) {
      setOpenConfirmSubmission(true);
    } else {
      window.alert('ຈຳນວນເງີນທີ່ຖອກຫລາຍກວ່າຈຳນວນເງິນທີ່ຈະຕ້ອງຖອກ');
    }
  };

  const handleCloseConfirmSubmission = () => {
    setOpenConfirmSubmission(false);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setCurrentPage(newPage);
  };

  const handleOpenViewOrderDetail = () => {
    setOpenViewOrder(true);
  };

  const handleCloseViewOrderDetail = () => {
    setOpenViewOrder(false);
  };

  const handleOpenConfirmForm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirmForm = () => {
    setOpenConfirm(false);
  };

  const handleSubmitClear = () => {
    handleClearMoneyDriver();
  };

  const handleOpenMenu = (event: any, getId: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedId(getId);
    const getBalanceData = selectedData?.balanceSubmission?.find((item) => item?.id === getId);
    setGetMoneyRiderPayment(getBalanceData?.totalMoney as number);
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  const rows = selectedData?.balanceSubmission?.slice(
    (currentPage - 1) * DEFAULT_ROWS_PER_PAGE,
    currentPage * DEFAULT_ROWS_PER_PAGE
  );

  const countPagination = Math.ceil(
    selectedData?.balanceSubmission?.length / DEFAULT_ROWS_PER_PAGE
  );

  const balanceSubmissionMoney = selectedData?.balanceSubmission
    ?.filter((item: BalanceModel) => item?.confirmIsStatus === true)
    ?.reduce((total, item) => total + (item?.totalMoney || 0), 0);

  const totalBalance = selectedData?.rider?.totalBalance?.total;

  const totalOnePay =
    selectedData?.ordersOnePay?.totalMoney === undefined
      ? 0
      : selectedData?.ordersOnePay?.totalMoney;

  const totalCash =
    selectedData?.ordersCash?.totalMoney === undefined ? 0 : selectedData?.ordersCash?.totalMoney;

  const totalSum = totalCash + totalOnePay;

  const totalReturnOrder =
    selectedData?.ordersReturn?.totalMoney === undefined
      ? 0
      : selectedData?.ordersReturn?.totalMoney;

  const orderCashDistance = selectedData?.ordersCash?.orders?.map(
    (item: OrderDriverFinancial) => item?.distance
  );
  const orderOnePayDistance = selectedData?.ordersOnePay?.orders?.map(
    (item: OrderDriverFinancial) => item?.distance
  );

  const totalDistance = (cash: any, onePay: any) => {
    const totalCash = Array.isArray(cash)
      ? cash.reduce((acc, value) => acc + parseFloat(value), 0)
      : 0;

    const totalOnePay = Array.isArray(onePay)
      ? onePay.reduce((acc, value) => acc + parseFloat(value), 0)
      : 0;

    const totalSum = totalCash + totalOnePay;
    const roundedTotal = totalSum.toFixed(2);
    return parseFloat(roundedTotal);
  };

  const getOrderCashMoney = selectedData?.ordersCash?.totalMoney ?? 0;

  const distanceRiderGot = totalDistance(orderCashDistance, orderOnePayDistance);
  const totalMoneyNeedToPay = getOrderCashMoney - balanceSubmissionMoney;

  const handleClearMoneyDriver = async () => {
    try {
      setLoadingButton(true);
      await axios.post(`${CLEAR_MONEY_DRIVER_FINANCIAL + selectedData?.id}`);
      onClose();
      await onFetchData();
    } catch (err) {
      // console.log(err);
    } finally {
      setLoadingButton(false);
    }
  };

  const handleConfirmSubmission = async () => {
    try {
      setLoadingButton(true);
      await axios.patch(CONFIRM_SUBMISSION + selectedId);
      setOpenConfirmSubmission(false);
      onClose();
      await onFetchData();
    } catch (err: any) {
      window.alert(err?.response?.data?.message);
    } finally {
      setLoadingButton(false);
      setOpenMenu(null);
    }
  };

  return {
    distanceRiderGot,
    rows,
    totalOnePay,
    balanceSubmissionMoney,
    totalBalance,
    totalSum,
    currentPage,
    handleChangePage,
    countPagination,
    handleOpenViewOrderDetail,
    handleCloseViewOrderDetail,
    handleOpenConfirmForm,
    handleCloseConfirmForm,
    openViewOrder,
    openConfirm,
    loadingButton,
    handleSubmitClear,
    totalMoneyNeedToPay,
    openMenu,
    handleCloseMenu,
    handleOpenMenu,
    handleCloseConfirmSubmission,
    handleOpenConfirmSubmission,
    handleConfirmSubmission,
    openConfirmSubmission,
    totalReturnOrder,
  };
};
export default useRiderBalanceDetailController;
